"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.permissionRequiredRender = void 0;
const RouteInterceptor_1 = require("../RouteInterceptor");
/**
 * If the permission is missing from the session, return a render action that renders
 * the FailureComponent
 *
 * @param permission       The required permission
 * @param failureComponent What to render if permission is missing
 * @category Interceptor
 */
const permissionRequiredRender = (permission, failureComponent) => ({ context }) => {
    const hasPermission = context?.session?.functions.some((fn) => fn.name === permission);
    if (!hasPermission) {
        return { kind: RouteInterceptor_1.RouteAction.RENDER_COMPONENT, component: failureComponent };
    }
    return null;
};
exports.permissionRequiredRender = permissionRequiredRender;
